import React from 'react'
import { Spin } from 'antd'
import TableRow from './TableRow'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'

const BrandsRuleTable = ({ loading, error, listBrandsRule }) => {
    const canViewStoreName = checkStoreName()
// console.log(listBrandsRule)
    const _renderTableContent = () => {
        if (listBrandsRule.length === 0 && !error) {
            return <tr>
                <td colSpan={8}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={8} className='text-danger'>{error}</td>
            </tr>
        }

        return listBrandsRule.length > 0 && listBrandsRule.map((item) => {
            return <TableRow
                key={item._id}
                item={item}
                listBrandsRule={listBrandsRule}
            />
        })
    }

    return (
        <div className='BrandsRuleTable SkuTable'>
            <Spin tip="Loading..." spinning={loading}>
                <table className="table table-striped">
                    <thead className="TableHead">
                        <tr>
                            <th className="Priority">Priority</th>
                            {canViewStoreName && <th className="Store">Store</th>}
                            <th className="ProductType">Product type</th>
                            <th className="BrandRule">Brand rule</th>
                            <th className="OrderType">Order type</th>
                            <th className="OrderTag">Order tag</th>
                            <th className="Time">Created - Updated</th>
                            <th className="Status">Status</th>
                            <th className="Action">Action</th>
                        </tr>
                    </thead>
                    <tbody className="TableBody">
                        {_renderTableContent()}
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default BrandsRuleTable